<template>
    <div :style="{height:height+'px',zIndex:zIndex}">
        <div
                :class="className"
                :style="{top:(isSticky ? stickyTop +'px' : ''),zIndex:zIndex,position:position,width:width,height:height+'px'}"
        >
            <slot>
                <div>sticky</div>
            </slot>
        </div>
    </div>
</template>

<script>
    /**
     *  Sticky header, 当页面滚动到预设的位置会吸附在顶部
     *  使用方法： 用<sticky>将吸顶元素包裹起来
     */
    export default {
        name: 'Sticky',
        props: {
            // fixed后距离顶端的高度
            stickyTop: {
                type: Number,
                default: 0
            },
            zIndex: {
                type: Number,
                default: 1
            },
            className: {
                type: String,
                default: ''
            },

            // 触发滚动的对象，不传则默认为window
            scroller: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                active: false,
                position: '',
                width: undefined,
                height: undefined,
                isSticky: false,
                scrollElement: window
            }
        },
        mounted() {
            this.height = this.$el.getBoundingClientRect().height

            if (this.scroller) {
                this.scrollElement = document.querySelector(this.scroller) || window
            }

            this.scrollElement.addEventListener('scroll', this.handleScroll)
            this.scrollElement.addEventListener('resize', this.handleResize)
        },
        activated() {
            this.handleScroll()
        },
        destroyed() {
            this.scrollElement.removeEventListener('scroll', this.handleScroll)
            this.scrollElement.removeEventListener('resize', this.handleResize)
        },
        methods: {
            sticky() {
                if (this.active) {
                    return
                }
                this.position = 'fixed'
                this.active = true
                this.width = this.width + 'px'
                this.isSticky = true
            },
            handleReset() {
                if (!this.active) {
                    return
                }
                this.reset()
            },
            reset() {
                this.position = ''
                this.width = 'auto'
                this.active = false
                this.isSticky = false
            },
            handleScroll() {
                const width = this.$el.getBoundingClientRect().width
                this.width = width || 'auto'
                const offsetTop = this.$el.getBoundingClientRect().top
                if (offsetTop < this.stickyTop) {
                    this.sticky()
                    return
                }
                this.handleReset()
            },
            handleResize() {
                if (this.isSticky) {
                    this.width = this.$el.getBoundingClientRect().width + 'px'
                }
            }
        }
    }
</script>
